export default function DtFormatter(dt: string) {
    return dt ? new Date(dt).toLocaleString() : "-";
}